import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Footer = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <footer className="footer" ref={ref}>
      <div className="container">
        <motion.div
          className="footer-content"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="footer-logo">
            <img src="/assets/logo.png" alt="Digify Logo" />
            <p>
              Helping businesses achieve digital freedom through innovative
              marketing solutions.
            </p>
          </div>

          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#services">Services</a>
              </li>
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#team">Team</a>
              </li>
              <li>
                <a href="#testimonials">Testimonials</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-services">
            <h3>Our Services</h3>
            <ul>
              <li>SEO Optimization</li>
              <li>Social Media Management</li>
              <li>Graphic Designing</li>
              <li>Promotions & Advertising</li>
              <li>Web Design & Development</li>
              <li>Digital Marketing</li>
            </ul>
          </div>

          <div className="footer-contact">
            <h3>Contact Us</h3>
            <p>digifyy.world@gmail.com</p>
            <p>+1 (555) 123-4567</p>
            <p>Delhi</p>
          </div>
        </motion.div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Digify.world. All rights reserved.
          </p>
          <div className="social-links">
            <a
              href="https://m.facebook.com/100090206379683/"
              aria-label="Facebook"
            >
              📘
            </a>

            <a
              href="https://www.instagram.com/digify.world?igsh=MXNoMHc3aGNjcWEycw=="
              aria-label="Instagram"
            >
              📷
            </a>
            <a
              href="https://www.linkedin.com/company/digify-world/"
              aria-label="LinkedIn"
            >
              💼
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
